import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  CashTransactionDeleteInput,
  CashTransactionModel,
  CashTransactionMutationInput,
  CashTransactionUpdateInput,
} from './model';

export function useCreateCashTransaction(
  options?: UseMutationOptions<
    ApiResult<CashTransactionModel>,
    ApiError,
    CashTransactionMutationInput
  >,
): UseMutationResult<
  ApiResult<CashTransactionModel>,
  ApiError,
  CashTransactionMutationInput
> {
  return useMutation<
    ApiResult<CashTransactionModel>,
    ApiError,
    CashTransactionMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'cash-transactions',
      method: 'POST',
      classType: CashTransactionModel,
      body,
    });
  }, options);
}

export function useUpdateCashTransaction(
  options?: UseMutationOptions<
    ApiResult<CashTransactionModel>,
    ApiError,
    CashTransactionUpdateInput
  >,
): UseMutationResult<
  ApiResult<CashTransactionModel>,
  ApiError,
  CashTransactionUpdateInput
> {
  return useMutation<
    ApiResult<CashTransactionModel>,
    ApiError,
    CashTransactionUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `cash-transactions/${body.cashTransactionId}`,
      method: 'PUT',
      classType: CashTransactionModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteCashTransaction(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    CashTransactionDeleteInput
  >,
): UseMutationResult<
  { message: string },
  ApiError,
  CashTransactionDeleteInput
> {
  return useMutation<{ message: string }, ApiError, CashTransactionDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `cash-transactions/${body.cashTransactionId}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}
